import * as R from "ramda";

const filterNill = R.reject(R.isNil);

export const formatPeriod = time => {
  if (time === 3600) {
    return `${time / 3600} hour`;
  } else if (time < 3600 && time >= 60) {
    return `${time / 60} min`;
  } else if (time < 60) {
    return `${time} sec`;
  }
};

export const formatPeriodRev = priod => {
  switch (priod) {
    case "30 min":
      return 1800;
    case "10 min":
      return 600;
    case "5 min":
      return 300;
    case "3 min":
      return 180;
    case "1 min":
      return 60;
    case "30 sec":
      return 30;
    case "15 sec":
      return 15;
    case "5 sec":
      return 5;
    default:
      return 300;
  }
};

export const formatUrl = R.curry((data, type) => {
  if (type === "HTTP(S)") {
    if (data.substring(0, 4).toLowerCase() === "http") {
      return data;
    } else {
      return `http://${data}`;
    }
  } else if (type === "TCP") {
    if (data.includes(":")) {
      return data;
    } else {
      return `${data}:80`;
    }
  }
  return data;
});

export const formatProbersOptions = array => {
  const getActive = R.filter(R.prop("is_active"));
  const filteredProbers = getActive(array);
  const probers = filteredProbers.map(el => {
    return {
      label: el.name,
      value: el.name,
      icon: el.datacenter.country_code,
      id: el.id,
      disabled: el.disabled
    };
  });
  const byIcon = R.groupBy(el => el.icon);
  return byIcon(probers);
};

export const filterByName = (array, probers) =>
  R.filter(R.where({ name: R.includes(R.__, probers) }), array);

export const mergeAll = R.mergeAll;

export const objectToArrayOfObjects = obj => {
  const arr = [];
  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      arr.push({ [property]: obj[property] });
    }
  }
  return arr.length === 0 ? [{}] : arr;
};

export const trimNum = R.curry((string, first, toEnd) => {
  return parseFloat(string.substring(first, string.length - toEnd));
});

export const objToArrOfObj = obj =>
  R.map(val => R.fromPairs([val]), R.toPairs(obj));

export const objOfArrToObjByVal = obj =>
  filterNill(R.map(R.prop("value"), R.flatten(R.values(obj))));

export const formatAlertToArr = obj =>
  R.flatten(R.values(R.omit(["id", "creation_time"], obj)));
